export enum TipoSurtidor{
    surtidor = 0,
    dispenser = 1
}